import {useFormik} from 'formik'
import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {useEffect, useState} from 'react'
import {TContractTermRequest} from '../../coreGlobal/models/admin/contractTerm'
import {useNavigate, useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import {getContractTermById, updateContractTerm} from './core/_request'
import {contractTermSchema} from './core/validation/ContractTermsVali'
import {ContractTermForm} from './components/ContractTermForm'
import {PageOverlayer} from '../../components/PageOverlayer'

const ContractTermBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin',
    path: '/admin/contract-terms',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const Update = () => {
  let {id} = useParams()
  const [loading, setLoading] = useState(false)
  const [loadingPage, setLoadingPage] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const getContractTerm = async () => {
      setLoadingPage(true)
      try {
        const data = await getContractTermById(String(id))
        formik.setValues({
          name: data.name,
          description: data.description,
          content: data.content ?? '',
        })
      } catch (error: any) {
        await Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: error?.response?.data?.message,
          showConfirmButton: true,
        })
        navigate('/admin/contract-terms', {replace: true})
      } finally {
        setLoadingPage(false)
      }
    }
    getContractTerm()
  }, [])

  const [contractTermInitialValues] = useState<TContractTermRequest>({
    name: '',
    description: '',
    content: '',
  })

  const formik = useFormik({
    initialValues: contractTermInitialValues,
    validationSchema: contractTermSchema,
    onSubmit: async (values) => {
      submit(values)
    },
  })

  const submit = async (req: TContractTermRequest) => {
    await Swal.fire({
      title: 'Deseja salvar o termo?',
      text: 'As alterações valem para os próximos PDFs gerados.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        try {
          await updateContractTerm(String(id), req)
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Salvo com sucesso',
            showConfirmButton: false,
            timer: 1500,
          })

          navigate('/admin/contract-terms', {replace: true})
        } catch (error: any) {
          if (error.response.status === 422) {
            let errorText = ''
            for (let key in error.response.data.errors) {
              errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
            }
            await Swal.fire({
              icon: 'error',
              title: 'Ops! Revise seu formulário e tente novamente!',
              html: errorText,
            })
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message,
              timer: 2000,
            })
          }
        } finally {
          setLoading(false)
        }
      }
    })
  }

  return <>{loadingPage ? <PageOverlayer /> : <ContractTermForm formik={formik} loading={loading} />}</>
}

export const ContractTermEditPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={ContractTermBreadcrumbs}>Atualizar Termo</PageTitle>
      <Update />
    </>
  )
}
